"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPPPaymentMethodService = void 0;
class OPPPaymentMethodService {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
        this.headers = {
            'Content-Type': 'application/json',
        };
        this.resourceHostId = `cwat-open-profile-payment-service-${this.stage}`;
    }
    async getPaymentMethods() {
        const response = await this.authService.get(this.resourceHostId, `v1/payment-methods`, this.headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return (await response.json());
    }
    async createPaymentMethod() {
        const response = await this.authService.post(this.resourceHostId, `v1/payment-methods`, JSON.stringify({
            type: 'CARD',
        }), this.headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return (await response.json());
    }
    async getPaymentMethod(paymentMethodId) {
        const response = await this.authService.get(this.resourceHostId, `v1/payment-methods/${paymentMethodId}`, this.headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return (await response.json());
    }
    async deletePaymentMethod(paymentMethodId) {
        const response = await this.authService.delete(this.resourceHostId, `v1/payment-methods/${paymentMethodId}`, undefined, this.headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
    async setPreferredPaymentMethod(paymentMethodId, preferred, trCardId) {
        const response = await this.authService.patch(this.resourceHostId, `v1/payment-methods/${paymentMethodId}`, JSON.stringify({
            preferred,
            trCardId,
        }), this.headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return (await response.json());
    }
    async setAddressForPaymentMethod(paymentMethodId, addressData) {
        const response = await this.authService.put(this.resourceHostId, `v1/payment-methods/${paymentMethodId}/address`, JSON.stringify(addressData), this.headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
}
exports.OPPPaymentMethodService = OPPPaymentMethodService;
//# sourceMappingURL=OPPPaymentMethodService.js.map